import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { CreateContainer, Header, MainContainer, Aqua, SETUP, Product, Fruits, Fish, Info, Plants} from "./components";
import { useStateValue } from "./context/StateProvider";
import { getAllFoodItems } from "./utils/firebaseFunctions";
import { actionType } from "./context/reducer";
import Footer from "./components/footer";

const App = () => {
  const [{ foodItems }, dispatch] = useStateValue();

  const fetchData = async () => {
    await getAllFoodItems().then((data) => {
      dispatch({
        type: actionType.SET_FOOD_ITEMS,
        foodItems: data,
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <AnimatePresence exitBeforeEnter>
      <div className="w-screen h-auto flex flex-col bg-primary">
        <Header />
        <main className="mt-14 md:mt-20 px-4 md:px-16 py-4 w-full">
          <Routes>
            <Route path="/*" element={<MainContainer />} />
            <Route path="/createItem" element={<CreateContainer />} />
            <Route path="/aqua" element={<Aqua />} />
            <Route path="/createItem" element={<CreateContainer />} />
            <Route path="/SETUP" element={<SETUP />} />
            <Route path="/Product" element={<Product />} />
            <Route path="/Fish" element={<Fish />} />
            <Route path="/Fruits" element={<Fruits />} />
            <Route path="/Info" element={<Info />} />
            <Route path="/Plants" element={<Plants />} />
          </Routes>
        </main>
        < Footer />
      </div>
    </AnimatePresence>
  );
};

export default App;
